import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  GET_PAYER_DAY_COUNT_SUCCESS,
  GET_PAYER_DAY_COUNT_FAILURE,
  GET_PAYER_DAY_COUNT_LOADING,
  GET_PAYER_DAY_COUNT_RESET,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  isSuccess: false,
};

export const getPayerDayCountReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_PAYER_DAY_COUNT_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: true,
      };
    }

    case GET_PAYER_DAY_COUNT_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };
    case GET_PAYER_DAY_COUNT_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_PAYER_DAY_COUNT_RESET:
      return intitialstate;

    default:
      return state;
  }
};
